import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useMutation } from 'react-query';
import { DONVIDAOTAO_API } from '@app/utils/apiUrl.js';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tenDonViDaoTao: yup.string().required('Tên đơn vị đào tạo không được để trống')
});

const DonViDaoTaoEdit = () => {
    const history = useHistory();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    const itemEdit = useQuery([itemId], () => Get(DONVIDAOTAO_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });
    const editFunc = useMutation((value) => Put(DONVIDAOTAO_API.UPDATE_ITEM, itemId, value));

    const handleEdit = async (values) => {
        editFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastUpdateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    if (itemEdit.isLoading) {
        return <div>Đang tải...</div>;
    }

    if (itemEdit.isError) {
        return <div>Có lỗi xảy ra: {itemEdit.error?.message}</div>;
    }

    if (!itemEdit.data) {
        return <div>Không tìm thấy đơn vị đào tạo.</div>;
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa đơn vị đào tạo</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        tenDonViDaoTao:
                            itemEdit.data.tenDonViDaoTao || itemEdit.data.TenDonViDaoTao || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên đơn vị đào tạo
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên đơn vị đào tạo"
                                        type="text"
                                        name="tenDonViDaoTao"
                                        value={values.tenDonViDaoTao}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenDonViDaoTao}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenDonViDaoTao}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={editFunc.isLoading}>
                                            Lưu
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default DonViDaoTaoEdit;
